import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done",
  "use": "done-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done\">\n    <circle cx=\"11\" cy=\"11\" r=\"11\" fill=\"#0099FF\" />\n    <path d=\"M7.69995 10.1279L10.2865 12.4L14.3 8\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol